import { useState } from 'react';
import './TagsInput.css';

function TagsInput({ tags = [], onChange }) {
  const [inputValue, setInputValue] = useState('');

  const handleAdd = () => {
    const newTag = inputValue.trim().toLowerCase();

    if (!newTag) {
      return;
    }

    // Prevent duplicates
    if (tags.some(tag => tag.toLowerCase() === newTag)) {
      setInputValue('');
      return;
    }

    onChange([...tags, inputValue.trim()]);
    setInputValue('');
  };

  const handleRemove = (tagToRemove) => {
    onChange(tags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    } else if (e.key === ',' || e.key === ';') {
      e.preventDefault();
      handleAdd();
    }
  };

  const handleKeyDown = (e) => {
    // Remove last tag on backspace if input is empty
    if (e.key === 'Backspace' && !inputValue && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  };

  return (
    <div className="tags-input">
      <div className="tags-container">
        {tags.map((tag, index) => (
          <span key={index} className="tag">
            {tag}
            <button
              type="button"
              className="tag-remove"
              onClick={() => handleRemove(tag)}
              title={`Remove ${tag}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>
        ))}
        <input
          type="text"
          className="tags-input-field"
          placeholder={tags.length === 0 ? "Add tags (press Enter or comma to add)" : "Add more..."}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDown}
        />
      </div>
      <p className="tags-hint">
        Press Enter, comma, or semicolon to add a tag. Press Backspace to remove the last tag.
      </p>
    </div>
  );
}

export default TagsInput;
